<!--周转补货单明细-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container view-orderquery">
    <el-form v-loading="listLoading" :model="viewObj" label-width="110px">
      <!--      基本信息-->
      <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
      <!--    公司编码  -->
      <el-form-item :label="$t('pmProductSppm.company')+':'">
        {{viewObj.companycode}}
      </el-form-item>
      <!--      单据编号-->
      <el-form-item :label="$t('poOrderAgent.provideno')+':'">
        {{viewObj.provideno}}
      </el-form-item>
      <!--      创建时间-->
      <el-form-item :label="$t('Common.createTime')+':'">
        {{viewObj.createTime}}
      </el-form-item>
      <!--      审核时间-->
      <el-form-item :label="$t('pmProductSppm.checkDate')+':'">
        {{viewObj.checkTime}}
      </el-form-item>
      <!--      备注-->
      <el-form-item :label="$t('poReturn.createRemark')+':'">
        {{viewObj.remark}}
      </el-form-item>
      <h3 style="color: #b3640d">{{ $t('busi.poMemberOrder.total.amount')+':'+' '+ viewObj.totalAmount+' '+ 'F$' }}</h3>
      <el-table
          :key="tableKey"
          :data="list"
          border
          size="mini"
          fit
          highlight-current-row
          style="width: 100%;"
      >
        <!--    商品编号  -->
        <el-table-column :label="$t('pmProductList.productId')" prop="goodscode" align="center" />
        <el-table-column :label="$t('BiGoods.goodsCode.old')" prop="oldcode" align="center" />
        <!--    商品名称-->
        <el-table-column :label="$t('BiGoods.name')" prop="name" align="center" />
        <!--    F$-->
        <el-table-column :label="$t('F$')" prop="unitAmount" align="center" />
        <!--    PV-->
        <el-table-column :label="$t('FV')" prop="unitFv" align="center" />
        <!--      是否赠品    -->
<!--        <el-table-column :label="$t('Is.it.a.physical.point')" prop="productForm" align="center">-->
<!--          <template v-slot="{row}">-->
<!--            {{$lt(initDict.physicalpoint,row.productForm)}}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <!--    订购数量-->
        <el-table-column :label="$t('poOrder.count')" prop="quantity" align="center" />
      </el-table>
      <div style="text-align: center; margin-bottom: 10px;margin-top: 10px" >
        <el-button size="mini" icon="el-icon-close" type="warning" @click="$router.back(-1)">{{ $t('operation.button.cancel') }}</el-button>
      </div>
    </el-form>
    </div>
  </div>
</template>

<script>
import {poOrderAgentView} from "@/api/agent";

export default {
  name: "TurnoverOrderView",
  data(){
    return{
      viewObj:{},
      tableKey:0,
      listLoading:false,
      list:[],
      viewTd:null,
      initDict: {
        status: 'po.order.status',
        payment: 'po.order.payment.cn',
        physicalpoint:'Is.it.a.physical.point'
      }
    }
  },
  created() {
    this.getView(this.$route.params.id)
  },
  methods:{
    getView(val){
      this.listLoading = true
      poOrderAgentView({'id':val}).then(res=>{
        this.viewObj = res.data
        this.list = res.data.details
        this.listLoading = false
      }).catch(err=>{
        this.listLoading = false
        this.$router.back()
        console.error(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
